"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const styles = (0, _makeStyles.default)(theme => ({
  root: {
    left: "50%",
    maxWidth: 350,
    padding: theme.spacing(0, 3),
    position: "fixed",
    top: theme.spacing(3),
    transform: "translate(-50%, 0)",
    width: "100%",
    zIndex: theme.zIndex.modal
  },
  content: {
    background: "#FFFFFF",
    boxShadow: "0 2px 36px -16px #00000080",
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(2, 3),
    textAlign: "center"
  },
  text: {
    lineHeight: 1.2,
    margin: theme.spacing(1, 0, 0)
  },
  buttons: {
    display: "flex",
    flexWrap: "wrap",
    gap: theme.spacing(1),
    justifyContent: "center",
    margin: theme.spacing(3, 0, 0)
  }
}));
var _default = exports.default = styles;